import { combineReducers } from 'redux';

import routes from './routes';
import tasks from './tasks';

export default combineReducers({
    routes,
    tasks,
});
